export default "__VITE_ASSET__9ed1b203__"